module.exports = __webpack_public_path__ + "static/media/movie.e69964d1.png";